import { TableRow } from "@/components/report/disease_risk/disease_risk_v1/medical_facility_report/commons";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import HelpButton from "../HelpButton";
import SimpleParagraphs from "./commons/SimpleParagraphs";

const TABLE_DATA: readonly {
  issue: string;
  evaluationIndexCandidate: string;
  evaluationIndexCandidateNote?: string;
}[] = [
  {
    issue: "ぐっすり眠れない",
    evaluationIndexCandidate: "睡眠効率もしくは中途覚醒時間",
  },
  {
    issue: "夜中に何度も目が覚める",
    evaluationIndexCandidate: "中途覚醒時間もしくは睡眠効率",
  },
  {
    issue: "夢をよく見る",
    evaluationIndexCandidate: "睡眠効率",
  },
  {
    issue: "トイレに起きることが多い",
    evaluationIndexCandidate: "トイレに起きた日の中途覚醒時間もしくは睡眠効率",
  },
  {
    issue: "寝付きが悪い",
    evaluationIndexCandidate: "入眠潜時",
  },
  {
    issue: "睡眠時間が短い",
    evaluationIndexCandidate: "睡眠時間",
    evaluationIndexCandidateNote:
      "睡眠時間が推奨睡眠時間の下限よりとれていれば問題なしと判定しています",
  },
  {
    issue: "自分の睡眠時間が適切かわからない",
    evaluationIndexCandidate: "睡眠時間",
  },
  {
    issue: "いびきをかく",
    evaluationIndexCandidate: "睡眠時無呼吸症候群リスク",
    evaluationIndexCandidateNote:
      "受診勧奨オプションありの場合のみ判定されます",
  },
  {
    issue: "寝ている間に呼吸が止まっていると言われる",
    evaluationIndexCandidate: "睡眠時無呼吸症候群リスク",
    evaluationIndexCandidateNote:
      "受診勧奨オプションありの場合のみ判定されます",
  },
  {
    issue: "早く目が覚めてしまいその後眠れない",
    evaluationIndexCandidate: "覚醒時刻～起床予定時刻の差",
  },
  {
    issue: "寝返りが多い",
    evaluationIndexCandidate: "睡眠の長さもしくは質",
  },
  {
    issue: "寝ても疲れが取れない",
    evaluationIndexCandidate:
      "睡眠のリズムもしくは長さもしくは質、もしくは睡眠時無呼吸症候群・不眠症リスク（受診勧奨オプションありの場合）",
  },
  {
    issue: "睡眠不足",
    evaluationIndexCandidate:
      "睡眠のリズムもしくは長さもしくは質、もしくは睡眠時無呼吸症候群・不眠症リスク（受診勧奨オプションありの場合）",
  },
  {
    issue: "寝起きが悪い",
    evaluationIndexCandidate:
      "睡眠のリズムもしくは長さもしくは質、もしくは睡眠時無呼吸症候群・不眠症リスク（受診勧奨オプションありの場合）",
  },
  {
    issue: "日中に眠気がある",
    evaluationIndexCandidate:
      "睡眠のリズムもしくは長さもしくは質、もしくは睡眠時無呼吸症候群・不眠症リスク（受診勧奨オプションありの場合）",
  },
  {
    issue: "その他",
    evaluationIndexCandidate: "自由入力のため判定なし",
  },
  {
    issue: "なし",
    evaluationIndexCandidate: "回答なしのため判定なし",
  },
];

export default function SelectedIssueHelpDialog() {
  return (
    <HelpButton dialogTitle="選択された課題" iconSx={{ color: "#D9D9D9" }}>
      <Stack gap={6}>
        <SimpleParagraphs
          paragraphs={[
            {
              title: "選択された課題とは",
              content:
                "事前問診にて「あなたが睡眠について最も気になっている課題に近いものを1つ選んでください。」という設問で受診者が選択した課題となります。\n課題に応じて、判定に使用する指標が異なります。判定指標が複数ある場合、受診者の測定結果に合わせて最も改善効果が高いと判断された指標が表示されています。",
              additionalContent: (
                <Typography
                  sx={{ fontWeight: "400", fontSize: "14px", color: "#707070" }}
                >
                  ※測定日数が3日以下の場合は判定不能となります。
                </Typography>
              ),
            },
          ]}
        />
        <TableContainer
          sx={{
            borderRadius: 0,
            "& tr": {
              "&:first-of-type": {
                borderTop: "1px solid #e0e0e0",
              },
              borderBottom: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              borderRight: "1px solid #e0e0e0",
            },
            "& .MuiTableCell-root": {
              borderBottom: "none",
            },
            "& th.MuiTableCell-root": {
              px: 0,
              py: 2,
              width: "50%",
              backgroundColor: "#f6f5f4",
              "&:first-of-type": {
                whiteSpace: "nowrap",
              },
              "&:not(:first-of-type) .MuiTypography-caption": {
                borderLeft: "1px solid #e0e0e0",
              },
              "& .MuiTypography-caption": {
                color: "#3d3d3d",
                px: 2,
              },
            },
            "& td.MuiTableCell-root": {
              px: 2,
              py: 3,
              fontSize: "13px",
              verticalAlign: "top",
              "&:not(:first-of-type)": {
                borderLeft: "1px solid #e0e0e0",
              },
            },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="caption">課題</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption">判定指標候補</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {TABLE_DATA.map(
                (
                  {
                    issue,
                    evaluationIndexCandidate,
                    evaluationIndexCandidateNote,
                  },
                  i
                ) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Typography
                        variant="body2"
                        fontSize="14px"
                        color="#3d3d3d"
                      >
                        {issue}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        fontSize="14px"
                        color="#3d3d3d"
                      >
                        {evaluationIndexCandidate}
                      </Typography>
                      {evaluationIndexCandidateNote && (
                        <Typography
                          variant="caption"
                          color="#707070"
                          fontSize="12px"
                        >
                          ※{evaluationIndexCandidateNote}
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </HelpButton>
  );
}
